import { z } from 'zod';
import { signedRecoveryBaselineCachePolicyV1Schema } from './baselineCachePolicySchemas';
import { fleetRecoveryCommandKeysSchema, fleetRecoverySha256Schema, fleetRecoveryUuidSchema,
  fleetRecoveryIdSchema, fleetRecoveryUint64Schema, fleetRecoverySignatureSchema } from '../fleetRecoverySchemas';

export const recoveryAuthorityDescriptorV1Schema = z.object({ schemaVersion: z.literal(1), executorVersion: z.literal(5),
  origin: z.string().max(2048).url().refine(value => new URL(value).protocol === 'https:' && new URL(value).origin === value),
  infrastructureDeploymentId: fleetRecoveryIdSchema, serverConfigurationSha256: fleetRecoverySha256Schema,
  releaseKeys: fleetRecoveryCommandKeysSchema, commandKeys: fleetRecoveryCommandKeysSchema,
  qualificationKeys: fleetRecoveryCommandKeysSchema, promotionKeys: fleetRecoveryCommandKeysSchema,
  reservationKeys: fleetRecoveryCommandKeysSchema,
}).strict();
export const recoveryHardeningConfigurationV1Schema = z.object({ algorithm: z.literal('Ed25519'), keyId: fleetRecoveryIdSchema,
  signature: fleetRecoverySignatureSchema, payload: z.object({ schemaVersion: z.literal(1),
    configurationId: fleetRecoveryUuidSchema, configurationGeneration: fleetRecoveryUint64Schema.refine(value => value !== '0'),
    authority: recoveryAuthorityDescriptorV1Schema, authorityConfigurationSha256: fleetRecoverySha256Schema,
  }).strict(),
}).strict();
export const hardeningTransitionV1Schema = z.object({ schemaVersion: z.literal(1),
  previousAuthorityConfigurationSha256: fleetRecoverySha256Schema,
  nextConfiguration: recoveryHardeningConfigurationV1Schema,
  nextCachePolicy: signedRecoveryBaselineCachePolicyV1Schema.optional(),
}).strict();
export type HardeningTransitionV1 = z.infer<typeof hardeningTransitionV1Schema>;
